import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const chartColors = {
  'net-total': theme.colors.success50,
  'fees-total': theme.colors.neutral20,
  'refund-total': theme.colors.critical50,
  paid: theme.colors.success40,
  outstanding: theme.colors.warning50,
};

export const flexColumnStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  minHeight: 0,
});
